// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2bOVO","productName":"Table_productName__3FLtL"};